import { CloseIcon } from './close-icon';
export default CloseIcon;
